/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveUpRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M13 5H19V11" }],
    ["path", { d: "M19 5L5 19" }]
  ]
];

export { MoveUpRight as default };
//# sourceMappingURL=move-up-right.js.map
